export const TITLE_APP_MOBILE = 'В приложении быстрее';
export const SUBTITLE_APP_MOBILE = 'Заполните анкету в приложении.\nЕщё пришлём пуш, когда банки пришлют свой ответ';
